import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { ROLE_LABELS } from '@wit-support/admin-contracts';
import { Avatar, Tooltip } from '@wit-support/ui';
import { cn } from './lib/cn.js';
import { computeInitials } from './lib/initials.js';
const SIZE_CLASSES = {
    sm: 'h-6 w-6 text-[10px]',
    md: 'h-8 w-8 text-xs',
    lg: 'h-10 w-10 text-sm',
};
export const AdminAvatar = React.forwardRef(({ admin, size = 'md', withTooltip = false, className }, ref) => {
    const initials = computeInitials(admin.displayName, admin.email);
    const sizeClass = SIZE_CLASSES[size];
    const fallbackStyle = {
        backgroundColor: `var(--color-role-${admin.role}-bg)`,
        color: `var(--color-role-${admin.role}-fg)`,
    };
    const avatar = (_jsx(Avatar, { ref: ref, className: cn(sizeClass, className), children: _jsx(Avatar.Fallback, { className: "font-medium", style: fallbackStyle, children: initials }) }));
    if (!withTooltip)
        return avatar;
    return (_jsx(Tooltip.Provider, { children: _jsxs(Tooltip.Root, { children: [_jsx(Tooltip.Trigger, { asChild: true, children: avatar }), _jsxs(Tooltip.Content, { children: [admin.displayName, " \u00B7 ", ROLE_LABELS[admin.role] ?? admin.role] })] }) }));
});
AdminAvatar.displayName = 'AdminAvatar';
//# sourceMappingURL=admin-avatar.js.map